// init.ts
window.global ||= window
